<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2" >
                <v-col cols="2" class="py-0" justify="center" align="center">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('pendings.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-col cols="2" class="py-0" v-if="$store.state.clients.length > 1">
                    <v-autocomplete ref="client_id" class="mt-0 py-0" v-model="client_id" :items="$store.state.clients" :label="$t('fulfillment_eon_pendings.client')" item-text="name" item-value="id"></v-autocomplete>
                </v-col>
                <v-col cols="2" class="py-0">
                    <datepicker :open_dialog="menu" :model="initial_date" :label="$t('product_per_fulfillment_report.initial_date')" @model="updateDate($event)" :rules_required="rules_required"></datepicker>
                </v-col>
                <v-col cols="2" class="py-0">
                    <datepicker :open_dialog="menu1" :model="final_date" :label="$t('product_per_fulfillment_report.final_date')" @model="updateDateFinal($event)" :rules_required="rules_required"></datepicker>
                </v-col>
                <v-col cols="4" align="end" class="py-0">
                    <v-btn class="right tools-view-height mr-3" outlined color="secondary" @click="exportData">
                        {{ $t('product_per_fulfillment_report.export') }}
                    </v-btn>
                    <v-btn class="right white_highlight--text tools-view-height" color="secondary" @click="generate">
                        {{ $t('product_per_fulfillment_report.generate') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import FileSaver from 'file-saver';

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('product_per_fulfillment_report.order'), align: "center", value: 'unique_order_number', class: 'text-uppercase' },
                { text: this.$t('product_per_fulfillment_report.customer'), align: "center", value: 'consignee_name', class: 'text-uppercase' },
                { text: this.$t('product_per_fulfillment_report.tracking_number'), align: "center", value: 'shipment_number', class: 'text-uppercase' },
                { text: this.$t('product_per_fulfillment_report.date'), align: "center", value: 'date', class: 'text-uppercase' },
                { text: this.$t('product_per_fulfillment_report.ready_date'), align: "center", value: 'ready_date', class: 'text-uppercase' },
                { text: this.$t('product_per_fulfillment_report.sku'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('product_per_fulfillment_report.product'), align: "center", value: 'description', class: 'text-uppercase' },
                { text: this.$t('product_per_fulfillment_report.quantity'), align: "center", value: 'quantity', class: 'text-uppercase' },
            ];
        },
        client: function(){
            return this.$store.state.clientId
        },
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            props: {
                search: '',
                items: [],
            },
            initial_date: '',
            final_date: '',
            report:{
                initial_date: '',
                final_date: ''
            },
            menu: false,
            menu1: false,
            client_id: this.$store.state.clients.length == 1 ? this.$store.state.clients.map(x => x.id).join(',') : '',
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.product_by_fulfillment_report";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        index(){
            this.props.items = [];
        },
        updateDate(newDate){
            this.initial_date = newDate;
        },
        updateDateFinal(date){
            this.final_date = date;
        },
        generate(){
            this.props.items = [];
            const show_fulfillment = this.$store.state.loggedUserPermissions.includes("customer_fulfillment.show") || this.$store.state.loggedUserPermissions.includes("advanced_customer_fulfillment.show") || this.$store.state.loggedUserPermissions.includes("customer_all_access.show")
            const show_fulfillment_eon = this.$store.state.loggedUserPermissions.includes("customer_fulfillment_eon.show") || this.$store.state.loggedUserPermissions.includes("customer_all_access.show") || this.$store.state.loggedUserPermissions.includes("customer_sedsa.show") 
            
            if(this.$store.state.warehouseId != "" && this.client_id != "" && this.initial_date != "" && this.final_date != ""){
                this.$store.state.loaderProps.visible = true;
                const lsToken = localStorage.getItem("access_token");
                this.$http.get(this.$store.state.chronosApi + 'reports/fulfillment?warehouse='+ this.$store.state.warehouseId + '&client='+ this.client_id + '&startDate='+ this.initial_date + '&endDate=' + this.final_date , {headers: {Authorization: lsToken}})
                .then((response) => {
                    this.props.items = response.data.data.filter(x => {
                        if(show_fulfillment && x.type == "Fulfillment") return x;
                        else if(show_fulfillment_eon && x.type == "FFX") return x;
                    })
                })
                .catch((response) => {
                    this.$store.state.loaderProps.visible = false;
                    if(response.status !== 200){
                        this.snackbar = {
                            visible: true,
                            color: 'red',
                            text: this.$t('pendings.responses.error')
                        }
                    }
                }).finally(() => {
                    this.$store.state.loaderProps.visible = false;
                });
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('yego_reports.export_error')
                };
            }
        },
        exportData(){
            if(this.$store.state.warehouseId != "" && this.client_id != "" && this.initial_date != "" && this.final_date != ""){
                this.$store.state.loaderProps.visible = true;
                const lsToken = localStorage.getItem("access_token");
                this.$http.get(this.$store.state.chronosApi + 'reports/fulfillmentExport?warehouse='+ this.$store.state.warehouseId + '&client='+ this.client_id + '&startDate='+ this.initial_date + '&endDate=' + this.final_date , {headers: {Authorization: lsToken}, responseType:'blob'})
                .then(response => {
                    this.$store.state.loaderProps.visible = false; 
                    FileSaver.saveAs(response.data, 'Productos_Por_Fulfillment.xlsx');
                })
                .catch(() => {
                    this.$store.state.loaderProps.visible = false;
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: this.$t('yego_reports.export_error')
                    };
                })
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('yego_reports.export_error')
                };
            }
        }
    }
}
</script>

<style>
</style>